<template>
  <PinterestEmbed
    v-if="provider === 'pinterest'"
    :elem="elem"
  />

  <YoutubeEmbed
    v-else-if="provider === 'youtube'"
    :elem="elem"
  />

  <div
    v-else-if="elem.attributes.oembed"
    :class="appEmbedClass"
    v-html="elem.attributes.oembed"
  />
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import PinterestEmbed from './PinterestEmbed.vue';
  import YoutubeEmbed from './YoutubeEmbed.vue';
  import type { EmbedAttributes } from '~/types/components/Embed';

  export default defineNuxtComponent({
    name: 'AppEmbed',

    components: { PinterestEmbed, YoutubeEmbed },

    props: {
      elem: {
        type: Object as PropType<TContent<EmbedAttributes>>,
        required: true,
      },
    },
    computed: {
      provider(): string {
        return this.elem.attributes.providerNameSlug;
      },

      appEmbedClass(): Record<string, boolean> {
        return {
          [`app-embed--${this.provider}`]: !!this.provider,
        };
      },
    },
  });
</script>
